// @ts-strict-ignore
import {Component, ConfigOptions} from 'panel';
import queryString from 'query-string';

import {commaizeNumber} from 'common/util';

import {template} from './template';
import './index.styl';
import {track, TrackEvents, TrackProperties} from './tracking';

const NO_INCUBATOR = `Select From the Dropdown`;
const PREVIOUS = `I used Mixpanel at a previous company.`;
const OTHER_INCUBATOR = `Other. My VC/accelerator is not listed.`;
const NONE = `I was not referred.`;
const FIVE_HUNDRED_STARTUPS = `500 Startups`;
const A16Z = `a16z`;
const ACCEL = `Accel`;
const ACE_STARTUPS = `ACE Startups`;
const AMERICAN_UNDERGROUND = `American Underground`;
const ANTHEMIS = `Anthemis`;
const ANTLER = `Antler`;
const ATOMIC_VC = `Atomic VC`;
const ATOMICO = `Atomico`;
const AWS_FOR_STARTUPS = `AWS for Startups`;
const B_CAPITAL = `B Capital`;
const BACKED_VC = `Backed VC`;
const BAIN_CAPITAL = `Bain Capital`;
const BALDERTON_CAPITAL = `Balderton Capital`;
const BASELINE = `Baseline`;
const BESSEMER = `Bessemer`;
const BETTER_CAPITAL = `Better Capital`;
const BITKRAFT = `BITKRAFT`;
const BLUME_VENTURES = `Blume Ventures`;
const BUILTFIRST = `Builtfirst`;
const CANARY = `Canary`;
const CHERRY_VENTURES = `Cherry Ventures`;
const CITIZENS = `Citizens`;
const CREANDUM = `Creandum`;
const DECIBEL_PARTNERS = `Decibel Partners`;
const DEV_STARTER_PACK = `Dev Starter Pack`;
const DIFC = `DIFC`;
const DIGITAL_CURRENCY_GROUP = `Digital Currency Group`;
const E14 = `E14`;
const EAST_VENTURES = `East Ventures`;
const EIGHT_ROADS = `Eight Roads`;
const ELRON_VENTURES = `Elron Ventures`;
const EMPRELATAM = `EmpreLatam`;
const ENDEAVOR = `Endeavor`;
const ENTR_E_CAPITAL = `Entrée Capital`;
const EVCA = `EVCA`;
const F6S = `F6S`;
const FIRST_ROUND_CAPTIAL = `First Round Captial`;
const FIRSTMARK_CAPITAL = `FirstMark Capital`;
const FIVE_ELMS_CAPITAL = `Five Elms Capital`;
const FLAT6LABS = `Flat6Labs`;
const FLOURISH_VENTURES = `Flourish Ventures`;
const FOOTHILL_VENTURES = `Foothill Ventures`;
const FORERUNNER_VENTURES = `Forerunner Ventures`;
const FOUNDERPASS = `FounderPass`;
const FOUNDERS_NETWORK = `Founders Network`;
const FORUM_VENTURES = `Forum Ventures`;
const GDWC_2025 = `GDWC 2025`;
const GENERAL_CATALYST = `General Catalyst`;
const GETPROVEN = `GetProven`;
const GGV_CAPITAL = `GGV Capital`;
const GOLD_HOUSE = `Gold House`;
const GOODWATER_CAPITAL = `Goodwater Capital`;
const GOOGLE = `Google`;
const GOOGLE_AD_SEARCH = `Google (ad, search)`;
const GOOGLE_FOR_STARTUPS = `Google for Startups`;
const GREYCROFT = `Greycroft`;
const GREYLOCK = `Greylock`;
const GRIFFIN = `Griffin`;
const HALA_VENTURES = `HALA Ventures`;
const HSBC = `HSBC`;
const HUSTLE_FUND = `Hustle Fund`;
const INDEX_VENTURES = `Index Ventures`;
const INNOVATE_CALGARY = `Innovate Calgary`;
const INSIGHT_PARTNERS = `Insight Partners`;
const INVESTTN = `InvestTN`;
const JUNGLE_VC = `Jungle VC`;
const KASZEK = `Kaszek`;
const KEYHORSE_CAPITAL = `Keyhorse Capital`;
const KFUND = `KFund`;
const KHOSLA_VENTURES = `Khosla Ventures`;
const KIMA_VENTURES = `Kima Ventures`;
const KLEINER_PERKINS = `Kleiner Perkins`;
const LAS_OLAS_VENTURE_CAPITAL = `Las Olas Venture Capital`;
const LATITUD = `Latitud`;
const LENNY_S_COMMUNITY = `Lenny's Community`;
const LIGHTSPEED = `Lightspeed`;
const LINKEDIN = `LinkedIn (ad, post, DM)`;
const LLM_SEARCH = `LLM Search (ChatGPT, Claude, Gemini)`;
const M13 = `M13`;
const MADICA = `Madica`;
const MAKERS_FUND = `Makers Fund`;
const MARKET_FIT_LAB = `Market Fit Lab`;
const MASSCHALLENGE = `MassChallenge`;
const MATTER = `Matter`;
const METAPLANET = `Metaplanet`;
const MICROSOFT_FOR_STARTUPS = `Microsoft for Startups`;
const MINDSET_VENTURES = `Mindset Ventures`;
const MONASHEES = `Monashees`;
const MRV_CATAPULT = `MRV Catapult`;
const MUCKER_CAPITAL = `Mucker Capital`;
const NEA = `NEA`;
const NOTABLE_CAPITAL = `Notable Capital`;
const ONDECK = `OnDeck`;
const PANTERA = `Pantera`;
const PARADIGM = `Paradigm`;
const PAYU = `PayU`;
const POLSKY_CENTER = `Polsky Center`;
const PORTERSHED = `PorterShed`;
const PRODUCT_SCHOOL = `Product School`;
const QUIET_CAPITAL = `Quiet Capital`;
const RAZORPAY = `Razorpay`;
const RAZORPAY_RIZE = `Razorpay Rize`;
const REDESIGN_HEALTH = `Redesign Health`;
const REDPOINT_VENTURES = `Redpoint Ventures`;
const RETOOL = `Retool`;
const SECRET = `Secret`;
const SEEDSTARS = `Seedstars`;
const SEQUOIA = `Sequoia`;
const SIERRA_VENTURES = `Sierra Ventures`;
const SIFTED = `Sifted`;
const SOFTBANK = `SoftBank`;
const SOMV = `SOMV`;
const SOSV = `SOSV`;
const SPEEDINVEST = `Speedinvest`;
const SPERO_VENTURES = `Spero Ventures`;
const SQUARE_PEG = `Square Peg`;
const START_UP_CHILE = `Start-Up Chile`;
const STARTUP_GRIND = `Startup Grind`;
const STARTUP_HEALTH = `StartUp Health`;
const STARTUP_SCHOOL_Y_COMBINATOR = `Startup School @ Y Combinator`;
const STARTUPBOOTCAMP = `Startupbootcamp`;
const STARTUPOS = `StartupOS`;
const STATION_F = `STATION F`;
const SURGE = `Surge`;
const TFBF = `Tech For Black Founders`;
const TECH_WEEK = `Tech Week`;
const TECHSTARS = `Techstars`;
const THE_VENTURE_CITY = `The Venture City`;
const TIGER_GLOBAL = `Tiger Global`;
const TOYOTA_VENTURES = `Toyota Ventures`;
const TWIST = `TWiST`;
const TWITTER_X = `Twitter/X (ad, post, DM)`;
const UBIQUITY_VENTURES = `Ubiquity Ventures`;
const ULU_VENTURES = `Ulu Ventures`;
const UNION_SQUARE_VENTURES = `Union Square Ventures`;
const UNREASONABLE = `Unreasonable`;
const VENTURE_KICK = `Venture Kick`;
const VERTEX_VENTURES = `Vertex Ventures`;
const VESTBEE = `Vestbee`;
const WAVEMAKER = `Wavemaker`;
const WING = `Wing`;
const WOW_ACELERADORA = `WOW Aceleradora`;
const XARTUP = `Xartup`;
const Y_COMBINATOR = `Y Combinator`;

const REFERRAL_INCUBATORS = [
  NO_INCUBATOR,
  PREVIOUS,
  OTHER_INCUBATOR,
  NONE,
  FIVE_HUNDRED_STARTUPS,
  A16Z,
  ACCEL,
  ACE_STARTUPS,
  AMERICAN_UNDERGROUND,
  ANTHEMIS,
  ANTLER,
  ATOMIC_VC,
  ATOMICO,
  AWS_FOR_STARTUPS,
  B_CAPITAL,
  BACKED_VC,
  BAIN_CAPITAL,
  BALDERTON_CAPITAL,
  BASELINE,
  BESSEMER,
  BETTER_CAPITAL,
  BITKRAFT,
  BLUME_VENTURES,
  BUILTFIRST,
  CANARY,
  CHERRY_VENTURES,
  CITIZENS,
  CREANDUM,
  DECIBEL_PARTNERS,
  DEV_STARTER_PACK,
  DIGITAL_CURRENCY_GROUP,
  DIFC,
  E14,
  EAST_VENTURES,
  EIGHT_ROADS,
  ELRON_VENTURES,
  EMPRELATAM,
  ENDEAVOR,
  ENTR_E_CAPITAL,
  EVCA,
  F6S,
  FIRST_ROUND_CAPTIAL,
  FIRSTMARK_CAPITAL,
  FIVE_ELMS_CAPITAL,
  FLAT6LABS,
  FLOURISH_VENTURES,
  FOOTHILL_VENTURES,
  FORERUNNER_VENTURES,
  FOUNDERPASS,
  FOUNDERS_NETWORK,
  FORUM_VENTURES,
  GDWC_2025,
  GENERAL_CATALYST,
  GETPROVEN,
  GGV_CAPITAL,
  GOLD_HOUSE,
  GOODWATER_CAPITAL,
  GOOGLE,
  GOOGLE_AD_SEARCH,
  GOOGLE_FOR_STARTUPS,
  GREYCROFT,
  GREYLOCK,
  GRIFFIN,
  HALA_VENTURES,
  HSBC,
  HUSTLE_FUND,
  INDEX_VENTURES,
  INNOVATE_CALGARY,
  INSIGHT_PARTNERS,
  INVESTTN,
  JUNGLE_VC,
  KASZEK,
  KEYHORSE_CAPITAL,
  KFUND,
  KHOSLA_VENTURES,
  KIMA_VENTURES,
  KLEINER_PERKINS,
  LAS_OLAS_VENTURE_CAPITAL,
  LATITUD,
  LENNY_S_COMMUNITY,
  LIGHTSPEED,
  LINKEDIN,
  LLM_SEARCH,
  M13,
  MADICA,
  MAKERS_FUND,
  MARKET_FIT_LAB,
  MASSCHALLENGE,
  MATTER,
  METAPLANET,
  MICROSOFT_FOR_STARTUPS,
  MINDSET_VENTURES,
  MONASHEES,
  MRV_CATAPULT,
  MUCKER_CAPITAL,
  NEA,
  NOTABLE_CAPITAL,
  ONDECK,
  PANTERA,
  PARADIGM,
  PAYU,
  POLSKY_CENTER,
  PORTERSHED,
  PRODUCT_SCHOOL,
  QUIET_CAPITAL,
  RAZORPAY,
  RAZORPAY_RIZE,
  REDESIGN_HEALTH,
  REDPOINT_VENTURES,
  RETOOL,
  SECRET,
  SEEDSTARS,
  SEQUOIA,
  SIERRA_VENTURES,
  SIFTED,
  SOFTBANK,
  SOMV,
  SOSV,
  SPEEDINVEST,
  SPERO_VENTURES,
  SQUARE_PEG,
  START_UP_CHILE,
  STARTUP_GRIND,
  STARTUP_HEALTH,
  STARTUP_SCHOOL_Y_COMBINATOR,
  STARTUPBOOTCAMP,
  STARTUPOS,
  STATION_F,
  SURGE,
  // TFBF,
  TECH_WEEK,
  TECHSTARS,
  THE_VENTURE_CITY,
  TIGER_GLOBAL,
  TOYOTA_VENTURES,
  TWIST,
  TWITTER_X,
  UBIQUITY_VENTURES,
  ULU_VENTURES,
  UNION_SQUARE_VENTURES,
  UNREASONABLE,
  VENTURE_KICK,
  VERTEX_VENTURES,
  VESTBEE,
  WAVEMAKER,
  WING,
  WOW_ACELERADORA,
  XARTUP,
  Y_COMBINATOR,
];

interface StartupsApplyState {
  incubator: string;
  otherIncubator: string;
  showOther: boolean;
  eligible: boolean;
  showCongrats: boolean;
  enrolled: boolean;
  credited: boolean;
  hasOtherCredit: boolean;
  eligibleForMigration: boolean;
  creditRedeemed: boolean;
  pastExpiry: boolean;
  currentPaid: boolean;
  loggedIn: boolean;
  org: number;
  initialValue: number;
  canUpdateBilling: boolean;
  formIsValid: boolean;
  requiredFields: {
    acceptsTerms: boolean;
  };
  showAcceptAgreementError: boolean;
  showRequireReferralError: boolean;
}

export class StartupsApply extends Component<StartupsApplyState> {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'logged-in': {type: `boolean`, description: `boolean value to indicate if user is logged in, defaults to false`},
      credited: {type: `boolean`, description: `has the user received for the credit already`},
      'has-other-credit': {type: `boolean`, description: `has the user received any non-startup credit`},
      'credit-redeemed': {type: `boolean`, description: `has redeemed the startup credit`},
      'eligible-for-migration': {
        type: `boolean`,
        description: `if current startup program account is eligible to migrate to new startup program.`,
      },
      'show-congrats': {
        type: `boolean`,
        description: `if show congrats page to user. The value is true when the user enrolls in program, value is false when user revisite the apply page.`,
      },
      enrolled: {type: `boolean`, description: `has the user enrolled in 2024 startup program`},
      eligible: {type: `boolean`, description: `is this account eligible for the startup program`},
      'past-expiry': {
        type: `boolean`,
        description: `if the user has the startups credit, whether or not it has expired`,
      },
      'has-implemented': {
        type: `boolean`,
        description: `if the organization has sent data to Mixpanel.`,
      },
      'implementation-ddl': {
        type: `string`,
        description: `deadline for the user to send data to mixpanel`,
      },
      'current-paid': {
        type: `boolean`,
        description: `if user is currently on a paid plan`,
      },
      'applied-date': {
        type: `string`,
        description: `The date user applied for startup program`,
      },
      expiration: {
        type: `string`,
        description: `if the user has the startups credit, this is when they expire. if the user enrolled startup program, this is the term end date.`,
      },
      org: {type: `number`, description: `org id of the org selected in the org choice modal`},
      'org-options': {type: `json`, description: `array of orgs that the user belongs to`},
      'initial-value': {type: `number`, description: `initial value of the startups credit`},
      'can-update-billing': {type: `boolean`, description: `whether the user is a billing administrator or not`},
      incubator: {type: `string`, description: `the incubator referral partner for the startup applying`},
      'tech-for-black-founders': {type: `boolean`, description: `is this user referred by Tech for Black Founders?`},
      'current-org-name': {type: `string`, description: `name of the org currently being modified`},
      'mp23-brand': {type: `boolean`, description: `boolean value to indiciate if mp2023 branding items should appear`},
    };
  }
  get config(): ConfigOptions<StartupsApplyState> {
    return {
      template,
      defaultState: {
        incubator: NO_INCUBATOR,
        otherIncubator: ``,
        showOther: false,
        credited: false,
        hasOtherCredit: false,
        eligibleForMigration: false,
        creditRedeemed: true,
        eligible: true,
        showCongrats: false,
        enrolled: false,
        pastExpiry: false,
        loggedIn: false,
        org: null,
        initialValue: null,
        canUpdateBilling: true,
        currentPaid: false,
        formIsValid: null,
        requiredFields: {
          acceptsTerms: null,
        },
        showAcceptAgreementError: false,
        showRequireReferralError: false,
      },
      helpers: {
        commaize: commaizeNumber,
        OTHER_INCUBATOR,
        REFERRAL_INCUBATORS,
        handleOtherInput: (otherIncubator) => {
          this.update({otherIncubator});
        },
        checkAndIsValid: () => {
          let isValid = true;

          //  check accept terms
          if (!this.state.requiredFields.acceptsTerms) {
            this.update({showAcceptAgreementError: true});
            isValid = false;
          } else {
            this.update({showAcceptAgreementError: false});
          }

          // check if other is selected and if so require a value
          if (this.state.incubator === OTHER_INCUBATOR) {
            if (!this.state.otherIncubator || !this.state.otherIncubator.trim()) {
              this.update({showRequireReferralError: true});
              isValid = false;
            } else {
              this.update({showRequireReferralError: false});
            }
          }

          this.update({formIsValid: isValid});
          return isValid;
        },
        handleAcceptsTermsClick: () => {
          this.update({
            requiredFields: {
              acceptsTerms: (this.state.requiredFields.acceptsTerms = !this.state.requiredFields.acceptsTerms),
            },
          });
          this.helpers.checkAndIsValid();
        },
        continueButtonDisabled: () =>
          !this.state.requiredFields.acceptsTerms ||
          this.state.incubator === NO_INCUBATOR ||
          (this.state.incubator === OTHER_INCUBATOR &&
            (!this.state.otherIncubator || !this.state.otherIncubator.trim())),
        handleSubmitForm: () => {
          track(TrackEvents.ClickStartupApplyNowButton, this.getTrackingProperties());

          if (this.helpers.checkAndIsValid()) {
            const next = encodeURIComponent(`/startups-apply/?incubator=${this.getIncubator()}`);
            const registerUrl = `/register/?creditStartup=1&incubator=${encodeURIComponent(
              this.getIncubator(),
            )}&next=${next}`;

            return this.state.loggedIn ? this.submitStartupsApplication() : (window.location.href = registerUrl);
          }
        },
        getIncubator: () => this.getIncubator(),
        updateReferralIncubator: (ev) => {
          const referralIncubator = ev.detail.value;
          this.update({incubator: referralIncubator, showOther: referralIncubator === OTHER_INCUBATOR});
        },
        isTFBF: () => this.attr(`tech-for-black-founders`) || this.state.incubator === TFBF,
        getPlanDetailUrl: () => {
          return this.attr(`org`) ? `/settings/org/${this.attr(`org`)}/plan` : `/`;
        },
        getOnboardingflowUrl: () => {
          return this.attr(`has-implemented`) ? `/` : `/report?immersive-onboarding=True`;
        },
        clickPlanDetail: (ev) => {
          ev.preventDefault();
          track(TrackEvents.StartupApplyToPlanDetail, this.getTrackingProperties());
          window.location.href = this.helpers.getPlanDetailUrl();
        },
        getPricingUrl: () => {
          return this.attr(`org`) ? `/pricing/plan-builder/?org=${this.attr(`org`)}` : `/pricing/plan-builder`;
        },
        clickPlanBuilder: (ev) => {
          ev.preventDefault();
          track(TrackEvents.StartupApplyToPlanBuilder, this.getTrackingProperties());
          window.location.href = this.helpers.getPricingUrl();
        },
        clickFreePlan: (ev) => {
          ev.preventDefault();
          track(TrackEvents.StartupApplyToFreePlan, this.getTrackingProperties());
          window.location.href = `/pricing`;
        },
        getOrgName: () => {
          return this.attr(`current-org-name`);
        },
      },
    };
  }

  getIncubator() {
    let incubator;
    switch (this.state.incubator) {
      case NO_INCUBATOR:
        incubator = `Not Provided`;
        break;
      case OTHER_INCUBATOR:
        incubator = this.state.otherIncubator || `Not Provided`;
        break;
      default:
        incubator = this.state.incubator;
        break;
    }
    return incubator;
  }

  connectedCallback() {
    super.connectedCallback();
    const update = {
      credited: this.attr(`credited`),
      hasOtherCredit: this.attr(`has-other-credit`),
      creditRedeemed: this.attr(`credit-redeemed`),
      eligibleForMigration: this.attr(`eligible-for-migration`),
      eligible: this.attr(`eligible`),
      showCongrats: this.attr(`show-congrats`),
      enrolled: this.attr(`enrolled`),
      canUpdateBilling: this.attr(`can-update-billing`),
      loggedIn: this.attr(`logged-in`),
      pastExpiry: this.attr(`past-expiry`),
      currentPaid: this.attr(`current-paid`),
      org: this.attr(`org`),
      initialValue: this.attr(`initial-value`),
      incubator: this.attr(`tech-for-black-founders`) ? TFBF : NO_INCUBATOR,
    };
    const queryParams = queryString.parse(window.location.search);
    if (queryParams.incubator) {
      update.incubator = queryParams.incubator as string;
    }
    this.update(update);
    let eventName = TrackEvents.ViewStartupsApplyPage;
    if (this.state.showCongrats) {
      eventName = TrackEvents.StartupProgramEnrolled;
    } else if (this.state.enrolled) {
      eventName = TrackEvents.ReapplyStartupProgram;
    } else if (this.state.credited && !this.state.pastExpiry) {
      eventName = TrackEvents.ViewStartupsThankYou;
    } else if (!this.state.eligible) {
      eventName = TrackEvents.RejectedByStartupProgram;
    }
    track(eventName, this.getTrackingProperties());
  }
  submitStartupsApplication() {
    const requestForm: any = document.getElementById(`mpStartupsApply`);
    track(TrackEvents.SubmitStartupsApplication, this.getTrackingProperties());
    requestForm.submit();
  }
  getTrackingProperties() {
    const trackProps = {
      [TrackProperties.IsLoggedIN]: this.attr(`logged-in`),
    };
    if (!this.state.eligible && ((this.state.credited && this.state.pastExpiry) || !this.state.enrolled)) {
      if (this.state.canUpdateBilling) {
        if (this.state.pastExpiry) {
          trackProps[TrackProperties.IneligibleReason] = `previously participated in startup program`;
        } else if (this.state.hasOtherCredit) {
          trackProps[TrackProperties.IneligibleReason] = `has other credit`;
        } else if (this.state.currentPaid) {
          trackProps[TrackProperties.IneligibleReason] = `currently paid`;
        } else {
          trackProps[TrackProperties.IneligibleReason] = `previously paid`;
        }
      } else {
        trackProps[TrackProperties.IneligibleReason] = `permissions`;
      }
    }

    trackProps[TrackProperties.ReferralPartner] = this.getIncubator();
    return trackProps;
  }
}
customElements.define(`mp-startups-apply`, StartupsApply);
